
import React from 'react';
const Assetanalytics = () =>{
    return (
        <div>Add Analytics</div>
      )
}

export default Assetanalytics;